import { takeLatest, put, call } from 'redux-saga/effects';
import swal from 'sweetalert';
import { history } from '@commons';

import { deleteControlePragaDoenca } from '../service';

import {
  DELETE_CONTROLE_PRAGA_DOENCA,
  DELETE_CONTROLE_PRAGA_DOENCA_PENDING,
  DELETE_CONTROLE_PRAGA_DOENCA_SUCCESS,
  DELETE_CONTROLE_PRAGA_DOENCA_FAILURE,
} from '../actionTypes';

import { AlertError, AlertWarning } from '@components/common/AlertToast';

function* sagaDeleteControlePragaDoenca(action) {
  yield put({ type: DELETE_CONTROLE_PRAGA_DOENCA_PENDING, id: action.id })

  try {
    const result = yield call(deleteControlePragaDoenca, action.id)

    if (result.status !== 204) {
      throw new Error('API delete request failed');
    }

    yield put({ type: DELETE_CONTROLE_PRAGA_DOENCA_SUCCESS, id: action.id })

    swal({
      title: 'Excluído!',
      icon: 'success',
      buttons: {
        cancel: false,
        confirm: {
          text: 'OK',
          value: true,
          visible: true,
          className: 'btn-primary',
          closeModal: true
        }
      }
    }).then(() => {
      history.go(0)
    });

  } catch (error) {

    yield put({ type: DELETE_CONTROLE_PRAGA_DOENCA_FAILURE })

    if (error.response?.status === 409) {
      const mensagem = error.response?.data?.message || 'Não é possível excluir este controle de praga/doença.';
      AlertWarning(mensagem);
    } else if (error.response?.status === 403) {
      AlertWarning('Controle de praga/doença não pode ser excluído');
    } else {
      AlertError('Falha ao excluir o registro! Tente novamente...');
    }
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchDeleteControlePragaDoenca() {
  yield takeLatest(DELETE_CONTROLE_PRAGA_DOENCA, sagaDeleteControlePragaDoenca)
}
